<template>
  <el-container class="gWidth">
    <el-aside width="200px">
      <el-menu
        :background-color="'#d3dce6'"
        :default-active="active"
        class="el-menu-vertical-demo"
        router
      >
        <el-menu-item index="abstracts">
          <span>关于我们</span>
        </el-menu-item>
        <el-menu-item index="contract">
          <span>法律声明</span>
        </el-menu-item>
        <el-menu-item index="certificate">
          <span>高新证书</span>
        </el-menu-item>
        <el-menu-item index="licence">
          <span>增值电信营许可证</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>
<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
export default {
  setup() {
    let active = ref('abstracts')
    let router = useRouter()
    active.value = router.currentRoute.value.name
    return {
      active
    }
  }
}
</script>

<style scoped lang="less">
.el-aside {
  background: #d3dce6;
}
.el-main {
  background: #fff;
}
.is-active {
  background: #fff;
}
</style>
